/**
 * Generates video frame thumbnails at given intervals from a video URL.
 * @param {string} videoUrl - The video source URL
 * @param {number} duration - The duration of the video (seconds)
 * @param {object} options - Additional options
 * @param {number} options.maxThumbnails - Maximum number of thumbnails to generate
 * @param {number} options.minThumbnails - Minimum number of thumbnails to generate
 * @param {number} options.interval - Custom interval between frames
 * @returns {Promise<{thumbnails: string[], interval: number, times: number[]}>} - Resolves to an object containing thumbnails, interval, and capture times
 */


export async function generateVideoFrames(videoUrl, duration, options = {}) {
    if (!videoUrl || !duration) return [];

    // Blob URL kontrolü - sadece blob URL'leri için thumbnail oluştur
    if(!videoUrl.startsWith('blob:')){
        // Blob URL değilse thumbnail oluşturma (https de CORS hatası alınacak)
        return { thumbnails: [], interval: 0, times: [] };
    }

    const maxThumbnails = options.maxThumbnails || 10;
    const minThumbnails = options.minThumbnails || 6;
    let interval = options.interval;

    if (!interval) {
        interval = duration / maxThumbnails;
        if (interval < 1) interval = 1;
        let count = Math.floor(duration / interval);
        if (count < minThumbnails) {
            interval = duration / minThumbnails;
        }
    }

    const generatedThumbnails = [];
    const captureTimes = [];
    for (let t = interval; t < duration; t += interval) {
        captureTimes.push(t);
    }
    if (captureTimes.length === 0 || captureTimes[captureTimes.length - 1] < duration - 0.1) {
        captureTimes.push(duration - 0.1);
    }
    const video = document.createElement('video');
    video.src = videoUrl;
    video.crossOrigin = 'anonymous';
    video.muted = true;
    video.preload = 'auto';
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    await new Promise(resolve => { video.onloadedmetadata = resolve; });
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    for (let i = 0; i < captureTimes.length; i++) {
        await new Promise(res => {
            video.currentTime = captureTimes[i];
            video.onseeked = () => {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                generatedThumbnails.push(canvas.toDataURL('image/jpeg', 0.7));
                res();
            };
        });
    }
    return { thumbnails: generatedThumbnails, interval, times: captureTimes };
}